import { useEffect, useState } from "react";
import "./OrdenKompralo.css";
import axios from "axios";
import { useParams } from "react-router-dom";
import logoKompralo from "../assets/Logo Kómpralo.png";
import { FiClock, FiLock, FiEye } from "react-icons/fi";

function OrdenKompralo() {

  const { token } = useParams();

  const [loading, setLoading] =
    useState(true);

  const [despacho, setDespacho] =
    useState(null);

  // ======================================
  // CARGAR ORDEN
  // ======================================

  useEffect(() => {

    cargarOrden();

  }, []);

  async function cargarOrden() {

    try {

      const response =
        await axios.get(

          `${process.env.REACT_APP_API_DESPACHOS}/${token}`
        );

      setDespacho(response.data);

    } catch (error) {

      console.error(error);

    } finally {

      setLoading(false);
    }
  }


  // ======================================
  // DATOS ORDEN
  // ======================================

  const tieneBonos =
    despacho?.digitalAssets &&
    despacho.digitalAssets.length > 0;

  const fechaCompra =
    despacho?.fecha
      ? new Date(despacho.fecha)
      : null;

  const fechaLimite =
    fechaCompra
      ? new Date(fechaCompra)
      : null;

  if (fechaLimite) {

    fechaLimite.setDate(
      fechaLimite.getDate() + 90
    );
  }

  const expirado =
    fechaLimite
      ? new Date() > fechaLimite
      : false;

  return (

    <div className="orden-page">

      <div className="orden-container">

        {/* HEADER */}

        <div className="orden-header">

          <img
            src={logoKompralo}
            alt="Kómpralo"
            className="orden-logo"
          />

          {tieneBonos && (
            <>
              <h1>
                <span className="saludo-nombre">
                  ¡Hola, {despacho.cliente?.split(" ")[0]}!
                </span>

                {" "}

                <span className="saludo-texto">
                  Bienvenido a tus bonos digitales
                </span>
              </h1>

              <hr className="orden-divider" />

              <div className="orden-vencimiento">

                {!expirado ? (

                  <>
                    <span>
                      Podrás descargar tus bonos hasta 90 días después de la fecha de entrega, disponibles hasta:
                      {" "}
                      <strong>
                        {fechaLimite.toLocaleDateString("es-CO")}
                      </strong>
                    </span>
                  </>

                ) : (

                  <>
                    <span>
                      Lo sentimos, el período de 90 días para descargar tus bonos después de la fecha de entrega ha finalizado.
                    </span>
                  </>

                )}

              </div>


              <p className="orden-info">
                Orden: <strong>#{despacho.wooOrderNumber}</strong>

                {" | "}

                Fecha entregado:{" "}
                <strong>
                  {despacho.fecha
                    ? new Date(despacho.fecha).toLocaleDateString("es-CO")
                    : "No disponible"}
                </strong>
              </p>
            </>
          )}

        </div>


        {/* BONOS */}

        <div className="bonos-container">

          {loading ? (

            <div className="orden-mensaje">
              Cargando bonos...
            </div>

          ) : !despacho ? (

            <div className="orden-mensaje error">
              ¡Orden no encontrada!
            </div>

          ) : !tieneBonos ? (

            <div className="orden-mensaje">
              ¡No hay bonos asignados!
            </div>

          ) : (

            despacho.digitalAssets.map((bono) => (

              <div
                key={bono._id}
                className="bono-card"
              >

                <div>

                  <h2>
                    {bono.nombre}
                  </h2>

                  <p>
                    Código: {bono.codigo}
                  </p>

                  <p>
                    Vigencia:{" "}
                    {new Date(
                      bono.fechaVencimiento
                    ).toLocaleDateString()}
                  </p>

                </div>

                <div className="botones-bono">

                  {bono.bloqueado ? (

                    <div className="btn-ver bono-disabled">
                      <FiLock />
                      <span>Bono no disponible</span>
                    </div>

                  ) : expirado ? (

                    <div className="btn-ver bono-disabled">
                      <FiClock />
                      <span>Descarga expirada</span>
                    </div>

                  ) : (

                    <a
                      href={`${process.env.REACT_APP_API_URL}/api/digital-assets/${bono._id}/pdf`}
                      target="_blank"
                      rel="noreferrer"
                      className="btn-ver"
                    >
                      <FiEye />
                      <span>Ver Bono</span>
                    </a>

                  )}

                </div>

              </div>

            ))

          )}

        </div>

        {/* FOOTER */}

        <div className="orden-footer">

          <img
            src="/logo192.png"
            alt="Kómpralo"
            className="orden-footer-logo"
          />

          <p>
            ¡Gracias por confiar en Kómpralo!
          </p>

        </div>
      </div>
    </div>
  );
}

export default OrdenKompralo;